module.exports = require("github:iamceege/tooltipster@3.3.0/js/jquery.tooltipster.min.js");